import React, { Component } from 'react';
import { connect } from 'react-redux';
import dates from 'react-big-calendar/lib/utils/dates';
import cn from 'classnames';
import * as TimeSlotUtils from 'react-big-calendar/lib/utils/TimeSlots';
import * as DayEventLayout from './DayEventLayout';
import TimeGridEvent from './TimeGridEvent';
import TimeSlotGroupDaily from './TimeSlotGroupDaily';
import { isSelected } from 'react-big-calendar/lib/utils/selection';
import _ from 'lodash';

class DayColumnDaily extends Component {
  constructor(...args) {
    super(...args);

    // this.slotMetrics = TimeSlotUtils.getSlotMetrics(this.props);
  }

  componentDidMount = () => {
    // this.slotMetrics = TimeSlotUtils.getSlotMetrics(this.props)
  };

  renderSlot = (idx, renderSlot, slotMetrics) => {
    if (idx !== 0) return null;
    const { getNow } = this.props;
    let employeeInfo = renderSlot || [];

    let headCounts = employeeInfo.length;

    const isNow = slotMetrics.dateIsInGroup(getNow(), idx);
    return (
      <span className={cn('rbc-label', isNow && 'rbc-now', 'spanstyle')} />
    );
  };

  // renderTotal = slotMetrics => {
  //   const { daysEvents, getNow, date } = this.props;
  //   let totalWorkingHours = 0.0;
  //   const min = dates.startOf(date, 'day');
  //   const max = dates.endOf(date, 'day');

  //   daysEvents.map(event => {
  //     let startTime = dates.max(event.start, min);
  //     let endTime = dates.min(event.end, max);
  //     const duration = (
  //       dates.diff(startTime, endTime, 'minutes') / 60.0
  //     ).toFixed(2);
  //     totalWorkingHours = totalWorkingHours + duration;
  //   });
  //   return (
  //     <span className={cn('rbc-label', 'spanstyle')}>{totalWorkingHours}</span>
  //   );
  // };

  renderEvents = slotMetrics => {
    let {
      daysEvents,
      rtl: isRtl,
      selected,
      accessors,
      localizer,
      getters,
      components,
      step,
      timeslots
    } = this.props;

    // const { slotMetrics } = this
    const { messages } = localizer;
    let events = daysEvents || [];
    // events.push(daysEvents[5]);

    let styledEvents = DayEventLayout.getStyledEvents({
      events,
      accessors,
      slotMetrics,
      minimumStartDifference: Math.ceil((step * timeslots) / 2)
    });

    return styledEvents.map(({ event, style }, idx) => {
      let end = event.end;
      let start = event.start;
      let format = 'eventTimeRangeFormat';
      let label;

      const startsBeforeDay = slotMetrics.startsBeforeDay(start);
      const startsAfterDay = slotMetrics.startsAfterDay(end);

      if (startsBeforeDay) format = 'eventTimeRangeEndFormat';
      else if (startsAfterDay) format = 'eventTimeRangeStartFormat';

      if (startsBeforeDay && startsAfterDay) label = messages.allDay;
      // else label = localizer.format({ start, end }, format);
      else label = event.Title || '';

      let continuesEarlier = startsBeforeDay || slotMetrics.startsBefore(start);
      let continuesLater = startsAfterDay || slotMetrics.startsAfter(end);

      return (
        <TimeGridEvent
          style={style}
          event={event}
          label={label}
          key={'evt_' + idx}
          getters={getters}
          isRtl={isRtl}
          components={components}
          continuesEarlier={continuesEarlier}
          continuesLater={continuesLater}
          accessors={accessors}
          selected={isSelected(event, selected)}
          onClick={e => this._select(event, e)}
          onDoubleClick={e => this._doubleClick(event, e)}
        />
      );
    });
  };

  render() {
    const {
      rtl,
      isNow,
      resource,
      accessors,
      localizer,
      daysEvents,
      date,
      step,
      timeslots
    } = this.props;

    const props = this.props;

    const min = dates.startOf(date, 'day');
    const max = dates.endOf(date, 'day');

    let slotMetrics = TimeSlotUtils.getSlotMetrics({
      min,
      max,
      step,
      timeslots
    });

    return (
      <div
        className={cn(
          'rbc-day-slot',
          isNow && 'rbc-now',
          isNow && 'rbc-today'
        )}
      >
        {slotMetrics.groups.map((grp, idx) => (
          <TimeSlotGroupDaily
            key={idx}
            group={grp}
            resource={resource}
            renderSlot={this.renderSlot}
            slotMetrics={slotMetrics}
            daysEvents={daysEvents}
          />
        ))}
        {/* <div className='rbc-time-slot'>
          {this.renderTotal(slotMetrics)}
        </div> */}
        <div className={cn('rbc-events-container', rtl && 'rtl')}>
          {this.renderEvents(slotMetrics)}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    displayWorkEvents: state.roster.displayAbsenceEvents,
    employees: state.roster.employeeList,
    selectedEmployee: state.roster.selectedEmployee,
    branches: state.BranchReducer.branchList,
    departments: state.DepartmentReducer.departmentList,
    actionTypes: state.ActionTypesReducer.actionTypes
  };
}

export default connect(mapStateToProps)(DayColumnDaily);
